import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import CategoryWiseIncidentsModal from './CategoryWiseIncidentsModal';
import { toast } from 'react-toastify';
import moment from 'moment';
import { NumberFormat } from '../../utils/NumberFormat';
const CategoryWiseIncidents = ({
  data,
  specificColor = false,
  total,
  isShowPercentage = false,
  incident_details,
}) => {
  const [state, setState] = useState(null);
  const [chartKey, setChartKey] = useState(0);
  const [genericColors, setGenericColors] = useState(null);
  const DEFAULT_INCIDENT_DETAILS_MODAL = {
    center_id: null,
    show: false,
    title: 'Incident Details',
    category: '',
  };
  const [showIncidentDetailsModal, setShowIncidentDetailsModal] = useState(
    DEFAULT_INCIDENT_DETAILS_MODAL
  );
  const [modalData, setModalData] = useState([]);
  const targetRef = useRef(null);

  useEffect(() => {
    setState({
      series: data?.data,
      options: {
        chart: {
          animations: {
            enabled: false,
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const selectedCategory = data?.categories[config.dataPointIndex];
              const selectedValue = data?.data[config.dataPointIndex];
              const incident_ids = {
                time: 1,
                center: 2,
                cctv: 3,
                rrb: 4,
                eca: 5,
                documents: 6,
                police: 7,
                malpractice: 8,
              };

              const selectedId = incident_ids[selectedCategory.toLowerCase()];

              if (selectedId) {
                const incidents = incident_details
                  .flat() // Flatten the array in case it's nested
                  .filter((incident) => incident.incident_id === selectedId)
                  .sort(
                    (b, a) =>
                      moment(a.date).valueOf() - moment(b.date).valueOf()
                  ); // Sort by date (ascending)

                // Step 3: Show data in modal if incidents are found
                if (incidents.length > 0) {
                  setModalData(incidents); // Save as an array of objects
                  setShowIncidentDetailsModal((prev) => ({
                    ...prev,
                    show: true,
                    category: selectedCategory,
                  }));
                } else {
                  toast.info(
                    `No incidents found for category: ${selectedCategory}`
                  );
                }
              } else {
                console.warn(`ID not found for category: ${selectedCategory}`);
              }
            },
          },
          type: 'donut',
        },
        legend: {
          show: false,
        },

        labels: data?.categories,
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const value = opts.w.config.series[opts.seriesIndex];
            if (isShowPercentage) {
              return `${value}%`;
            } else {
              return value;
            }
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '55%',
            },
          },
        },
        colors: !specificColor
          ? genericColors
          : ['#2C9A32', '#FF7F3F', '#F39C12', '#ED1D24', '#A5A5A5'],
      },
    });
    if (state) {
      const maxValue = Math.max(...state.series);

      setGenericColors(
        state.series.map((value) => {
          const baseColor = '#F44336';
          if (value === maxValue) {
            return '#ED1D24';
          }

          const opacity = 0.2 + (value / maxValue) * 0.8;
          return `${baseColor}${Math.round(opacity * 255)
            .toString(16)
            .padStart(2, '0')}`;
        })
      );

      setState((prevState) => ({
        ...prevState,
        options: {
          ...prevState.options,
        },
      }));
      setChartKey((prevKey) => prevKey + 1);
    }
  }, [data]);

  return (
    <>
      {total && state ? (
        <div className='position-relative d-flex justify-content-center align-items-center'>
          <span className='position-absolute fw-bold mb-3'>{NumberFormat(total)}</span>
          <span className='position-absolute mt-3'>Records</span>
          {state && (
            <ReactApexChart
              key={chartKey}
              options={state.options}
              series={state.series}
              type='donut'
              height={200}
            />
          )}
        </div>
      ) : (
        <>
          {state && (
            <ReactApexChart
              key={chartKey}
              options={state.options}
              series={state.series}
              type='donut'
              height={200}
            />
          )}
          {showIncidentDetailsModal.show && (
            <CategoryWiseIncidentsModal
              showIncidentDetailsModal={showIncidentDetailsModal}
              setShowIncidentDetailsModal={setShowIncidentDetailsModal}
              incidents={modalData}
            />
          )}
        </>
      )}
    </>
  );
};
export default CategoryWiseIncidents;
